import React from "react";
import styles from "./styles.module.scss";
import GGLogoIco from "../../../../../public/images/gg_logo.svg";
import ToolTip from "app/routes/Scheduling/ToolTip";
import {formatTitle, isShowingTooltip} from "../utils";

const ScheduleItem = ({ schedule }: any) => {

  const month = schedule.date.split(" ")[0];
  const day = schedule.date.split(" ")[1];

  const duration = schedule.duration + " mins";

  return (
    <div className={styles.container}>
      <div className={`${styles.date} ${schedule.type === "lesson_schedule" ? styles.bg_lesson : styles.bg_program}`}>
        <div className={styles.month}>{month}</div>
        <div className={styles.day}>{day}</div>
      </div>

      <div className={styles.content}>
        <div className={styles.title}>
          {formatTitle(schedule.title)}
          {isShowingTooltip(schedule.title) && (
            <div className={styles.toolTipPosition}>
              <ToolTip selected={true} text={schedule.title} orientation={'right'} />
            </div>
          )}
        </div>
        <div className={styles.user_profile}>
          <img className={styles.profile_image} src={schedule.profile_image || GGLogoIco} alt={"profile_image"}/>
          <div className={styles.name}>{schedule.name}</div>
        </div>
      </div>

      <div className={styles.time_container}>
        <div className={styles.time}>{schedule.time}</div>
        <div>{duration}</div>
      </div>
    </div>
  );
};

export default ScheduleItem;
